import { render, staticRenderFns } from "./trainee.math.timestable.statistic.vue?vue&type=template&id=a84047d2&scoped=true&"
import script from "./trainee.math.timestable.statistic.vue?vue&type=script&lang=ts&"
export * from "./trainee.math.timestable.statistic.vue?vue&type=script&lang=ts&"
import style0 from "./trainee.math.timestable.statistic.vue?vue&type=style&index=0&id=a84047d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a84047d2",
  null
  
)

export default component.exports